<input type="text" i18n-placeholder placeholder="Искать" (input)="onInput($event.target.value)" [value]="value" (focus)="focus = true" (focusout)="focus = false">
<app-icon *ngIf="!focus">search</app-icon>
<app-icon *ngIf="focus" class="clear" (mousedown)="onInput(null)">clear</app-icon>